import { handleSkeletonRow, removeSkeletonRow } from "../../../../../entrypoints/vanila/nota_fiscal";
import { store } from '../store';
const associationElBodyTableWithPath = {
  '/nota_fiscals': 'table-body-nfes-emitidas',
}

export const PARAMS_MULTISELECT = ['cfop'];

export function normalizarParamsMultiselect(params) {
  PARAMS_MULTISELECT.forEach(nomeParametro => {
    const valorConcatenado = params.get(nomeParametro);
    if (valorConcatenado && valorConcatenado.includes(',')) {
      const valoresIndividuais = valorConcatenado.split(',').map(valorIndividual => valorIndividual.trim());
      params.delete(nomeParametro);
      valoresIndividuais.forEach(valorIndividual => params.append(`${nomeParametro}[]`, valorIndividual));
    }
  });
  return params;
}

function paramsURL() {
  const url = new URL(window.location.href);
  const params = new URLSearchParams(url.search);
  const paramsObject = Object.fromEntries(params);
  return {
    url,
    params,
    paramsObject
  };
}

export function aplicaFiltroEmURL(filtro, valor, path) {
  const _el = document.getElementById(associationElBodyTableWithPath[path])

  let valorParsed;
  const { url, params } = paramsURL();
  if (filtro.includes('data')) {
    valorParsed = converteData(valor);
  } else {
    valorParsed = valor;
  }

  const keyFiltroAdvanced = filtro.replace('_exact', '');
  const advancedSetting = store.state.advancedSettings[keyFiltroAdvanced];
  if (advancedSetting) {
    const removeParam = advancedSetting === 'exact' ? '' : '_exact';
    params.delete(keyFiltroAdvanced+removeParam);
  }

  params.set(filtro, valorParsed);
  url.search = params.toString();
  if (params.get('limpar_filtro')) {
    params.delete('limpar_filtro');
    url.search = params.toString();
  }
  if (!params.get('filtro_aplicado')) {
    params.set('filtro_aplicado', 'true');
    url.search = params.toString();
  }
  aplicaParametroNoSessionStorage('filtro_aplicado', 'true');
  window.history.pushState({}, '', url);
  applyFiltersToListagem(path, _el);
}

export function removeFiltroDaURL(filtro, path) {
  const _el = document.getElementById(associationElBodyTableWithPath[path])

  const { url, params } = paramsURL();
  params.delete(filtro);
  url.search = params.toString();
  window.history.pushState({}, '', url);
  applyFiltersToListagem(path, _el);
}

export function limparFiltrosDaURL(path) {
  const _el = document.getElementById(associationElBodyTableWithPath[path])

  const url = new URL(window.location.href);
  url.search = '';
  const params = new URLSearchParams(url.search);
  params.set('limpar_filtro', 'true');
  url.search = params.toString();
  window.history.pushState({}, '', url);
  aplicaParametroNoSessionStorage('filtro_aplicado', 'false');
  applyFiltersToListagem(path, _el);
}

export function capturaFiltrosDaURL() {
  const { params } = paramsURL();
  const filtros = {};
  const arrayFiltro = [];
  for (const [key, value] of params) {
    arrayFiltro.push(key);
    filtros[key] = value;
  }
  return {
    arrayFiltro,
    filtros
  };
}

let applyFiltersTimeout = null;
function applyFiltersToListagem(path, element) {
  handleSkeletonRow()

  if (applyFiltersTimeout) {
    clearTimeout(applyFiltersTimeout);
  }
  
  const ids = coletarIdsSelecionados(element);
  applyFiltersTimeout = setTimeout(() => {
    try {
      const { paramsObject } = paramsURL();
      const transformedParams = Object.fromEntries(
        Object.entries(paramsObject).map(([key, value]) => {
          if (value && typeof value === 'string' && value.includes(',')) {
            return [key, value.split(',').map(item => item.trim())];
          }
          return [key, value];
        })
      );

      delete transformedParams.format;

      $.rails.ajax({
        url: path || window.location.pathname,
        type: 'GET',
        dataType: 'script',
        data: {
          ...transformedParams,
          filtro_aplicado: true,
          ids_notas_selecionadas: ids
        },
      });
    } catch (error) {
      console.error('Erro ao aplicar filtro na listagem', error);
    } finally {
      removeSkeletonRow();
    }
  }, 300);
}

export function renderFiltroSelect(filtroAplicado, itens, filterKey) {
  if (filtroAplicado) {
    itens.forEach(item => {
      if (item.id == filtroAplicado) {
        filterKey.id = item.id;
        filterKey.name = item.name;
      }
    });
  }
}

export function removeAccents(str) {
  if (typeof str !== 'string') return str;
  return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

function aplicaParametroNoSessionStorage(param, value) {
  const sessionStorage = window.sessionStorage;
  if (!sessionStorage.getItem(param)) {
    sessionStorage.setItem(param, value);
  }
}

function converteData(data) {
  if (typeof data !== 'string') return data;

  if (/^\d{2}\/\d{2}\/\d{4}$/.test(data)) {
    return data;
  }

  if (/^\d{2}-\d{2}-\d{4}$/.test(data)) {
    const [dia, mes, ano] = data.split('-');
    return `${dia}/${mes}/${ano}`;
  }

  if (/^\d{4}-\d{2}-\d{2}$/.test(data)) {
    const [ano, mes, dia] = data.split('-');
    return `${dia}/${mes}/${ano}`;
  }

  return data;
}

function coletarIdsSelecionados(element) {
  if (!element) return [];
  
  const ids = [];
  element.querySelectorAll('input[type="checkbox"]:checked').forEach(item => {
    ids.push(item.value);
  });
  return ids;
}
